import { Typography } from "@mui/material";
import React from "react";
import "../../cssfiles/homepage.css";

export default function SystemSetup() {
    return (
        <div className="compliance-config">
            <Typography className="config-heading" style={{ fontSize: '36px', fontWeight: 700, color: "var(--HighlightedText_Stroke)" }}>System Setup</Typography>
            <Typography className='config-info' style={{ fontSize: '14px', fontWeight: 400, color: "var(--GreyVariation_4)" }}>Customize settings based on your personal preferences. This is for your user login only and does not affect other users in your organization.</Typography>
        </div>
    )
}